import error from "../pages/404";

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.

export default [
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../pages/LoginPage.vue"),
  },
  {
    path: "/zapier-auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/AuthorizeZapierPage"),
  },
  {
    path: "/integration-auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/IntegrationAuthPage"),
  },
  {
    path: "/validate-account",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/ValidateAccount"),
  },
  {
    path: "/sign-up",
    component: () =>
      import(/* webpackChunkName: "register" */ "../pages/RegisterAccountPage"),
  },
  {
    path: "/email-validated",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/EmailValidatedPage"),
  },
  {
    path: "/email-not-validated",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/EmailNotValidatedPage"),
  },
  {
    path: "/sign-up/appsumo",
    component: () =>
      import(/* webpackChunkName: "register" */ "../pages/RegisterAccountPage"),
  },
  {
    path: "/forgot-password",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/ForgotPasswordPage"),
  },
  {
    path: "/update-password",
    component: () =>
      import(
        /* webpackChunkName: "auth" */ "../pages/UpdatePasswordViaLinkPage"
      ),
  },
  {
    path: "/accept-invite",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/AcceptInvitePage"),
  },
  {
    path: "/overview",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/OverviewPage"),
  },
  {
    path: "/dashboard",
    redirect: "/overview",
  },
  {
    path: "/proof-archive",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofArchivePage"),
  },
  {
    path: "/proof-list",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofListPage"),
  },
  {
    path: "/proof-item",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofItemPage"),
  },
  {
    path: "/proof-details",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofDetailsPage"),
  },
  {
    path: "/knowledge-base",
    component: () =>
      import(/* webpackChunkName: "knowledge-base" */ "../pages/KnowledgeBasePage"),
  },
  {
    path: "/knowledge-base-article",
    component: () =>
      import(/* webpackChunkName: "knowledge-base" */ "../pages/KnowledgeBaseArticlePage"),
  },
  {
    path: "/contact-archive",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ApproverArchivePage"),
  },
  {
    path: "/approver-item",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ApproverItemPage"),
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: "/contact-details",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ContactDetailsPage"),
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: "/workflows",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/WorkflowsPage"),
  },
  {
    path: "/email-templates",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/EmailTemplatesPage"),
  },
  {
    path: "/checklists",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ChecklistsPage"),
  },
  {
    path: "/automation-archive",
    redirect: "/workflows",
  },
  {
    path: "/preflights",
    component: () =>
      import(
        /* webpackChunkName: "internal" */ "../pages/PreflightsPage"
      ),
  },
  {
    path: "/workflow-item",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/WorkflowItem"),
  },
  {
    path: "/template-item",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/TemplateItemPage"),
  },
  {
    path: "/profile",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProfilePage"),
  },
  {
    path: "/account",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/AccountPage"),
  },
  {
    path: "/mcp",
    component: () => import(/* webpackChunkName: "internal" */ "../pages/McpPage"),
  },
  {
    path: "/users",
    component: () =>
        import(/* webpackChunkName: "internal" */ "../pages/UsersPage"),
  },
  {
    path: "/billing",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/BillingPage"),
  },
  {
    path: "/cancel",
    component: () => 
      import(/* webpackChunkName: "internal" */ "../pages/BillingPage"),
  },
  {
    path: "/create",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/CreatePage"),
  },
  {
    path: "/create-proof",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/CreateProofPage"),
  },
  {
    path: "/thanks",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ThankYou"),
  },
  {
    path: "/success",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ThankYou"),
  },
  {
    path: "/compare/*",
    component: () =>
        import(/* webpackChunkName: "external" */ "../pages/ComparePage"),
  },
  {
    path: "/review/*",
    component: () =>
        import(/* webpackChunkName: "external" */ "../pages/ReviewPage.router"),
  },
  {
    path: "/captains-deck",
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeck"),
  },
  {
    path: "/captains-deck/health",
    meta: { title: "Account Health" },
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeckHealth"),
  },
  {
    path: "/captains-deck/review/:accountId",
    meta: { title: "Business Review" },
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeckReview"),
  },
  {
    path: "/onboarding",
    component: () =>
      import(/* webpackChunkName: "onboarding" */ "../pages/Onboarding.vue"),
  },
  {
    path: "/jobs",
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobList.vue"),
  },
  {
    path: "/jobs/report",
    meta: { title: "Jobs Report" },
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobReport.vue"),
  },
  {
    path: "/job-details/:id",
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobDetails.vue"),
  },
  {
    path: "/job-status",
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobStatus.vue"),
  },
  {
    path: "/artwork-intake",
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeList.vue"),
  },
  {
    path: "/files",
    component: () =>
      import(/* webpackChunkName: "files" */ "../pages/FilesList.vue"),
  },
  {
    path: "/artwork-intake/submission/:id",
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeDetails.vue"),
    props: true,
  },
  {
    path: "/artwork-intake/settings",
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeSettings.vue"),
  },
  {
    path: "/artwork-intake-form/:formId",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/ArtworkIntakeFormPublic.vue"),
  },
  {
    path: "/portal/:accountPublicId",
    alias: "/portal/:accountPublicId/login",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/PortalLoginPage.vue"),
  },
  {
    path: "/portal/:accountPublicId/proofs",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/PortalProofsPage.vue"),
  },
  {
    path: "/403",
    component: () => import(/* webpackChunkName: "auth" */ "../pages/UnAuth"),
  },
  { path: "*", component: error }, //must be last
];

//https://router.vuejs.org/guide/essentials/navigation.html
